import React, { useState } from 'react';
import axios from 'axios';
import { API } from '../../context/SiteConfigContext';

const LoginView = ({ onLogin }) => {
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const { data } = await axios.post(`${API}/admin/login`, { password });
      localStorage.setItem('exotic_admin_token', data.token);
      onLogin(data.token);
    } catch (err) {
      setError('Mot de passe incorrect');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0e2a24] text-white grid place-items-center px-6">
      <form onSubmit={submit} className="w-full max-w-sm rounded-xl border border-white/10 bg-white/[0.03] p-8">
        <div className="font-serif text-2xl">Exotic Tours <span className="text-[#e0b972]">Admin</span></div>
        <p className="mt-2 text-[13px] text-white/60">Connectez-vous pour éditer le site.</p>
        <label className="mt-6 block text-[11px] tracking-[0.2em] uppercase text-white/50">Mot de passe</label>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="mt-2 w-full rounded-md bg-transparent border border-white/15 focus:border-[#e0b972] focus:outline-none px-3.5 py-2.5 text-[14px] text-white transition-colors"
          autoFocus
        />
        {error && <p className="mt-2 text-[12px] text-[#f27a5b]">{error}</p>}
        <button
          type="submit"
          disabled={loading}
          className="mt-5 w-full rounded-md bg-[#e89142] hover:bg-[#d97e2f] disabled:opacity-70 text-[#1a1a1a] font-medium py-2.5 text-sm transition-colors"
        >
          {loading ? '…' : 'Se connecter'}
        </button>
        <a href="/" className="mt-4 block text-center text-[12px] text-white/40 hover:text-white/70 transition-colors">← Retour au site</a>
      </form>
    </div>
  );
};

export default LoginView;
